import { auth } from '../config/firebase';
import serverConfig from '../config/server-port.json';

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://narrativeos-3e3dee189b73.herokuapp.com/api'
  : 'http://localhost:5001/api';

// Helper function to get auth headers
export const getAuthHeaders = () => {  
  const credentials = btoa('tylersabino:QwErTy123!');
  return {
    'Authorization': `Basic ${credentials}`
  };
};

// Get a signed URL for a GCS object
export const getSignedUrl = async (gsUrl) => {
  // console.log('Getting signed URL for:', gsUrl);
  try {
    // console.log('Making request to:', `${API_URL}/signed-url?gsUrl=${encodeURIComponent(gsUrl)}`);
    const response = await fetch(`${API_URL}/signed-url?gsUrl=${encodeURIComponent(gsUrl)}`, {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        ...getAuthHeaders()
      }
    });
    
    // console.log('Response status:', response.status);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error response:', errorData);
      throw new Error(errorData.error || 'Failed to get signed URL');
    }
    
    const data = await response.json();
    // console.log('Received signed URL:', data.signedUrl);
    return data.signedUrl;
  } catch (error) {
    console.error('Error getting signed URL:', error);
    return null; // Return null instead of throwing to allow fallback to previewUrl
  }
};

// Convert GCS URLs to signed URLs in project data
export const convertGcsUrlsToSigned = async (project) => {
  // console.log('Converting GCS URLs for project:', project.id);
  try {
    if (!project.images || !Array.isArray(project.images)) {
      // console.log('No images array found in project');
      return project;
    }

    const updatedImages = await Promise.all(
      project.images.map(async (image) => {
        // console.log('Processing image:', image.url);
        if (image.url && image.url.startsWith('gs://')) {
          // console.log('Found GCS URL, getting signed URL');
          const signedUrl = await getSignedUrl(image.url);
          // console.log('Got signed URL:', signedUrl);
          return {
            ...image,
            signedUrl: signedUrl || image.url // Only fallback to original gs:// URL
          };
        }
        // console.log('Not a GCS URL, skipping');
        return image;
      })
    );

    return {
      ...project,
      images: updatedImages
    };
  } catch (error) {
    console.error('Error converting GCS URLs to signed URLs:', error);
    return project;
  }
};

export { API_URL }; 